import { render, staticRenderFns } from "./DetalleVacaciones.vue?vue&type=template&id=524df7e3"
import script from "./DetalleVacaciones.vue?vue&type=script&lang=js"
export * from "./DetalleVacaciones.vue?vue&type=script&lang=js"
import style0 from "./DetalleVacaciones.vue?vue&type=style&index=0&id=524df7e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports